
import { Component, Vue } from 'vue-property-decorator'
import { NavBar, MenuBar, TaskQuestionCard, TaskReorderWordsCard, TaskFillTheBlankCard, TaskSelectChoiceCard, TaskHighlightTextCard, TaskTransformExpressionCard, TaskMatchExpressionsCard } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

@Component({
  components: {
    MenuBar,
    NavBar,
    TaskQuestionCard,
    TaskReorderWordsCard,
    TaskFillTheBlankCard,
    TaskSelectChoiceCard,
    TaskHighlightTextCard,
    TaskTransformExpressionCard,
    TaskMatchExpressionsCard
  }
})
export default class TaskView extends Vue {
  data () {
    return {
      taskId: null,
      taskType: '',
      taskObj: null
    }
  }

  mounted () {
    this.taskId = this.$route.params.taskId
    this.getTaskData()
  }

  async getTaskData () {
    this.isLoading = true
    try {
      var resp = await FetchWrapper.get(encodeURI(`${process.env.VUE_APP_SERVERURL}/getTaskData${this.taskId ? '/' + this.taskId : ''}`))
      this.taskObj = resp
      this.taskType = resp.type
      // this.taskType = 'MATCH_EXPRESSIONS'
      /* if (!this.taskId) {
        this.taskId = resp.id
      } */
      this.isLoading = false
    } catch (e) {
      this.taskData = null
      this.isLoading = false
      this.$buefy.dialog.confirm({
        title: 'Error',
        message: `Could not get task data. ${e}`,
        canCancel: false
      })
    }
  }
}
